(function () {
  'use strict';
  const catalog = window.mvpChurchCatalog || {};
  const page = document.body.dataset.page;
  const events = window.mvpPrototypeEvents = window.mvpPrototypeEvents || [];
  const storageKey = 'mvp-church-commerce-quote-v1';
  const track = (name, parameters = {}) => events.push({
    name, parameters: { source_page: page, ...parameters }, timestamp: new Date().toISOString()
  });

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-track]');
    if (link) track(link.dataset.track, { product: link.dataset.product || '', destination: link.getAttribute('href') });
    const navigation = event.target.closest('.category-nav a, .category-card, .related-card, .project-products a');
    if (navigation) track('church_nav_click', { destination: navigation.getAttribute('href') });
  });
  document.querySelectorAll('.faq').forEach(faq => faq.addEventListener('toggle', () => {
    if (faq.open) track('church_faq_open', { question: faq.querySelector('summary').textContent.trim() });
  }));

  const searchForm = document.querySelector('[data-search-form]');
  if (searchForm) {
    const input = searchForm.querySelector('input');
    const results = document.querySelector('#search-results');
    const renderSearch = () => {
      const query = input.value.trim().toLowerCase();
      results.replaceChildren();
      results.hidden = !query;
      input.setAttribute('aria-expanded', String(Boolean(query)));
      const status = searchForm.querySelector('[data-search-status]');
      status.textContent = '';
      if (!query) return;
      const tokens = query.split(/\s+/);
      const matches = Object.entries(catalog).filter(([, product]) => {
        const text = `${product.name} ${product.tag} ${product.detail} ${product.search_terms || ''} church displays`.toLowerCase();
        return tokens.every(token => text.includes(token.length > 3 ? token.replace(/s$/, '') : token));
      });
      status.textContent = matches.length + (matches.length === 1 ? ' product found.' : ' products found.');
      if (!matches.length) {
        const message = document.createElement('p');
        message.textContent = 'No matching products. Try “flags”, “banners”, “backdrops”, or “tents”.';
        message.setAttribute('role', 'status');
        results.append(message);
      }
      matches.forEach(([key, product]) => {
        const link = document.createElement('a');
        link.href = product.page + '.html#' + product.anchor;
        link.dataset.track = 'church_search_result_click';
        link.dataset.product = key;
        const image = document.createElement('img');
        image.src = 'assets/product-photography/' + product.image;
        image.width = image.height = 48;
        image.alt = '';
        const label = document.createElement('span');
        label.textContent = product.name;
        const price = document.createElement('small');
        price.textContent = product.price;
        label.append(price);
        link.append(image, label);
        results.append(link);
      });
    };
    input.addEventListener('input', renderSearch);
    input.addEventListener('focus', () => { if (input.value.trim()) renderSearch(); });
    searchForm.addEventListener('submit', event => {
      event.preventDefault();
      renderSearch();
      track('church_catalog_search', { result_count: results.querySelectorAll('a').length });
      const first = results.querySelector('a');
      if (first) first.focus();
    });
    searchForm.addEventListener('keydown', event => {
      if (event.key === 'Escape') { input.focus(); results.hidden = true;input.setAttribute('aria-expanded','false'); }
      if (event.key === 'ArrowDown' && event.target === input) {
        event.preventDefault();
        results.querySelector('a')?.focus();
      }
    });
    document.addEventListener('click', event => { if (!searchForm.contains(event.target)) {results.hidden = true;input.setAttribute('aria-expanded','false');} });
    searchForm.addEventListener('focusout', () => window.setTimeout(() => {
      if (!searchForm.contains(document.activeElement)) {results.hidden = true;input.setAttribute('aria-expanded','false');}
    }, 0));
  }

  const form = document.querySelector('[data-quote-form], .quote-content form.contact-form');
  if (!form) return;
  const nativeSubmission = (() => {
    const action = form.getAttribute('action') || '';
    try { return new URL(action, window.location.href).pathname === '/contact' && Boolean(action); }
    catch { return false; }
  })();
  const disclosure = document.querySelector('[data-quote-disclosure]');
  const success = document.querySelector('[data-quote-success]');
  const summary = document.querySelector('[data-quote-summary]');
  const error = document.querySelector('[data-quote-error]');
  const saveMessage = document.querySelector('[data-save-message]');
  const tidy = text => text.replace(/\s*\/\s*/g, ' · ').replace(/\s+/g, ' ').trim();
  const optionLabel = record => record.height ? `${record.height} ft · ${record.printing==='double'?'double-sided':'single-sided'} · ${record.base==='cross'?'cross base + water bag':'ground stake'}` : tidy(record.title);
  const quantity = value => Number.isInteger(Number(value)) && Number(value) > 0 && Number(value) <= 99999;
  const fieldNames = ['notes', 'organization', 'name', 'email', 'neededBy'];
  const field = name => form.querySelector(`[data-quote-field="${name}"]`);
  const quoteBody = form.querySelector('[data-quote-body]');
  const quoteSourcePage = form.querySelector('[data-quote-source-page]');
  const quoteLandingPage = form.querySelector('[data-quote-landing-page]');
  const quoteSubmissionId = form.querySelector('[data-quote-submission-id]');
  const quoteSubmittedAt = form.querySelector('[data-quote-submitted-at]');
  const makeSubmissionId = () => `church-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  const submissionId = makeSubmissionId();
  const variantCatalog = window.mvpChurchVariants || {};
  let selectedVariants = [];
  const variantRecord = selection => variantCatalog[selection.product]?.find(v => v.id === Number(selection.id));
  let started = false;
  let sourcePage = page;
  let saveTimer;

  const read = () => ({
    version: 1,
    sourcePage,
    products: [...form.querySelectorAll('[name=products]:checked')].map(control => control.value),
    variants: selectedVariants.filter(selection => form.querySelector(`[name=products][value="${selection.product}"]`)?.checked),
    ...Object.fromEntries(fieldNames.map(name => [name, field(name).value.trim()]))
  });

  try {
    const saved = JSON.parse(localStorage.getItem(storageKey));
    if (saved?.version === 1) {
      // Personal fields are page-scoped; never restore legacy stored identity.
      saved.variants=Array.isArray(saved.variants)?saved.variants.map(v=>({...v,design:''})):[];
      localStorage.setItem(storageKey, JSON.stringify({version:1,sourcePage:saved.sourcePage,products:saved.products,variants:saved.variants}));
      if (Array.isArray(saved.products)) form.querySelectorAll('[name=products]').forEach(control => { control.checked = saved.products.includes(control.value); });
      if (typeof saved.sourcePage === 'string') sourcePage = saved.sourcePage;
      if (Array.isArray(saved.variants)) selectedVariants = saved.variants.filter(selection => selection && catalog[selection.product] && variantRecord(selection)).map(selection => ({product:selection.product,id:Number(selection.id),quantity:quantity(selection.quantity)?Number(selection.quantity):1,design:typeof selection.design==='string'?selection.design.slice(0,200):''}));
      saveMessage.textContent = 'Saved product selections restored. Please enter your contact details.';
    }
  } catch { saveMessage.textContent = 'Browser storage is unavailable. You can still prepare and copy a request.'; }

  const renderVariants = () => {
    const list = document.querySelector('[data-quote-variant-list]');
    list.replaceChildren();
    const state = read();
    document.querySelector('[data-quote-configurations]').hidden = !state.products.length;
    const updateBadges = () => document.querySelectorAll('[data-quote-count]').forEach(el => { el.textContent = state.products.length ? '(' + (state.variants.length + state.products.filter(key => !state.variants.some(v => v.product === key)).length) + ')' : ''; });
    updateBadges();
    const removeSelection = selection => {
      selectedVariants = selectedVariants.filter(v => v !== selection);
      if (!selectedVariants.some(v => v.product === selection.product)) form.querySelector(`[name=products][value="${selection.product}"]`).checked = false;
      save();
      const next = list.querySelector('button');
      (next || field('notes')).focus();
    };
    for (const selection of state.variants) {
      const record = variantRecord(selection);
      const item = document.createElement('li');
      item.dataset.quoteItem = selection.product;
      const body = document.createElement('div');body.className = 'quote-item-body';
      const name = document.createElement('strong');name.textContent = catalog[selection.product].name;
      const description = document.createElement('p');description.textContent = optionLabel(record);body.append(name, description);
      const fields = document.createElement('div');fields.className = 'quote-item-fields';
      const qtyLabel = document.createElement('label');qtyLabel.textContent = 'Quantity';
      const qty = document.createElement('input');qty.type = 'number';qty.min = '1';qty.max = '99999';qty.step = '1';qty.required = true;qty.value = selection.quantity;qty.inputMode = 'numeric';qty.dataset.itemQuantity = selection.product;qty.setAttribute('aria-label','Quantity: '+name.textContent+' '+tidy(record.title));
      qty.addEventListener('input', () => { selection.quantity = Number(qty.value);save(false); });
      qtyLabel.append(qty);
      const designLabel = document.createElement('label');designLabel.textContent = 'Design or message (optional)';
      const design = document.createElement('input');design.type = 'text';design.maxLength = 200;design.value = selection.design || '';design.dataset.itemDesign = selection.product;design.placeholder = 'e.g. Guest parking';
      design.addEventListener('input', () => { selection.design = design.value;save(false); });designLabel.append(design);fields.append(qtyLabel,designLabel);body.append(fields);
      const edit = document.createElement('details');edit.className = 'quote-item-edit';
      const editLabel = document.createElement('summary');editLabel.textContent = 'Change options';
      const selectLabel = document.createElement('label');selectLabel.textContent = 'Product options';
      const select = document.createElement('select');select.dataset.editVariant = selection.product;
      for (const option of variantCatalog[selection.product]) {
        const el = document.createElement('option');el.value = option.id;el.textContent = optionLabel(option)+(option.available?'':' — unavailable');el.disabled = !option.available;el.selected = option.id === selection.id;select.append(el);
      }
      select.addEventListener('change', () => {
        const other = selectedVariants.find(v => v !== selection && v.product === selection.product && v.id === Number(select.value) && v.design === selection.design);
        if (other && other.quantity + selection.quantity <= 99999) { other.quantity += selection.quantity; selectedVariants = selectedVariants.filter(v => v !== selection); }
        else selection.id = Number(select.value);
        save();
        list.querySelector(`[data-quote-item="${selection.product}"] summary`)?.focus();
      });
      selectLabel.append(select);edit.append(editLabel,selectLabel);body.append(edit);
      const duplicate = document.createElement('button');duplicate.type='button';duplicate.textContent='Add another design';duplicate.dataset.duplicateQuote='';duplicate.addEventListener('click',()=>{selectedVariants.push({product:selection.product,id:selection.id,quantity:1,design:''});save();const inputs=[...list.querySelectorAll('[data-item-design]')];inputs[inputs.length-1].focus();});body.append(duplicate);
      const remove = document.createElement('button');remove.type = 'button';remove.dataset.removeConfiguration='';remove.textContent = 'Remove';remove.setAttribute('aria-label','Remove configuration: '+name.textContent+' '+tidy(record.title));remove.addEventListener('click',()=>removeSelection(selection));
      item.append(body,remove);list.append(item);
    }
    for (const key of state.products.filter(key => !state.variants.some(v => v.product === key))) {
      const item = document.createElement('li');const label = document.createElement('span');label.textContent = catalog[key].name+' · options to confirm';
      const remove = document.createElement('button');remove.type = 'button';remove.textContent = 'Remove';remove.setAttribute('aria-label','Remove '+catalog[key].name);remove.addEventListener('click',()=>{form.querySelector(`[name=products][value="${key}"]`).checked=false;save();field('notes').focus();});item.append(label,remove);list.append(item);
    }
  };
  const save = (render = true) => {
    if (render) renderVariants();
    try { localStorage.setItem(storageKey, JSON.stringify({version:1,sourcePage,products:read().products,variants:read().variants.map(v=>({...v,design:''}))}));saveMessage.textContent = 'Product selections saved in this browser. Contact details stay on this page.'; }
    catch { saveMessage.textContent = 'Your draft could not be saved. Prepare and copy it before leaving this page.'; }
  };
  const requestText = () => {
    const state = read();
    return [
      'MVP Visuals: Church display quote request',
      `Church or organization: ${state.organization}`,
      `Name: ${state.name}`,
      `Email: ${state.email}`,
      '', 'PRODUCTS',
      ...(state.products.length ? state.products.map(key => `• ${catalog[key]?.name || key}`) : ['Please help me choose a product.']),
      ...(state.variants.length ? ['', 'ITEMS AND OPTIONS', ...state.variants.map(selection => {
        const record = variantRecord(selection);
        return `• ${selection.quantity} × ${catalog[selection.product].name}: ${record.title.replace(/\s+/g, ' ')}${selection.design ? "\n  Design: " + selection.design : ""}\n  ${record.url}`;
      })] : []),
      '', `Quantities, sizes, or questions: ${state.notes || 'Not provided'}`,
      `Requested delivery date: ${state.neededBy || 'Not provided'}`,
      'Delivery timing requires confirmation.',
      `Page: ${state.sourcePage}`,
      `Landing page: ${window.location.href}`,
      `Submission ID: ${submissionId}`,
      ...(!nativeSubmission ? ['', 'DRAFT: Copy and send this request to MVP Visuals.'] : [])
    ].join('\n');
  };
  const edit = () => {
    success.hidden = true;
    form.hidden = false;
    document.querySelector('[data-copy-status]').textContent = '';
  };
  const openQuote = (products = '', variantId = '', quietly = false, requestedQuantity = '') => {
    products.split(',').filter(key => catalog[key]).forEach(key => {
      form.querySelector(`[name=products][value="${key}"]`).checked = true;
    });
    const product = products.split(',')[0];
    const parsedQuantity = Math.max(1, Math.min(999, Math.round(Number(requestedQuantity) || 1)));
    const selection = { product, id: Number(variantId), quantity:parsedQuantity, design:'' };
    const existing = selectedVariants.find(v => v.product === product && v.id === selection.id);
    if (variantId && variantRecord(selection) && !existing) selectedVariants.push(selection);
    else if (existing && requestedQuantity) existing.quantity = parsedQuantity;
    edit();
    if (!quietly) disclosure.open = true;
    save();
    const toast = document.querySelector('[data-quote-toast]');
    if (quietly && toast) {
      document.querySelector('[data-quote-toast-message]').textContent = catalog[product].name + ' added to your quote.';
      toast.hidden = false;
      track('church_quote_add', { product });
      return;
    }
    if (toast) toast.hidden = true;
    track('church_quote_open', { selected_products: read().products.join(',') });
    document.querySelector('#quote').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    (document.querySelector('[data-quote-configurations]').hidden ? field('notes') : document.querySelector('#quote-items-title')).focus({ preventScroll: true });
  };
  document.querySelectorAll('[data-quote-products]').forEach(trigger => trigger.addEventListener('click', event => {
    event.preventDefault();
    if (trigger.getAttribute('aria-disabled') === 'true') return;
    openQuote(trigger.dataset.quoteProducts, trigger.dataset.quoteVariant, Boolean(trigger.dataset.quoteVariant), trigger.dataset.quoteQuantity);
  }));
  document.querySelector('[data-dismiss-toast]')?.addEventListener('click', () => { document.querySelector('[data-quote-toast]').hidden = true; });
  disclosure.addEventListener('toggle', () => {
    if (disclosure.open) track('church_quote_view', { selected_products: read().products.join(',') });
  });
  form.addEventListener('input', event => {
    if (!started) { track('church_quote_start'); started = true; }
    event.target.removeAttribute('aria-invalid');event.target.removeAttribute('aria-describedby');
    error.hidden = true;
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(() => save(false), 150);
  });
  form.addEventListener('change', event => {
    if (event.target.name === 'products' && !event.target.checked) selectedVariants = selectedVariants.filter(v => v.product !== event.target.value);
    save(!event.target.closest('[data-quote-item]'));
  });
  form.addEventListener('submit', event => {
    const invalidQuantity = [...form.querySelectorAll('[data-item-quantity]')].find(input => !input.validity.valid || !quantity(input.value));
    if (invalidQuantity) { event.preventDefault();error.textContent = 'Enter a whole-number quantity from 1 to 99,999.';error.hidden = false;invalidQuantity.setAttribute('aria-invalid','true');invalidQuantity.setAttribute('aria-describedby','quote-error');invalidQuantity.focus();return; }
    const required = ['organization', 'name', 'email'];
    const invalid = required.filter(name => {
      const control = field(name);
      const valid = control.value.trim() && control.validity.valid;
      if (valid) control.removeAttribute('aria-invalid');
      else {control.setAttribute('aria-invalid', 'true');control.setAttribute('aria-describedby','quote-error');}
      return !valid;
    });
    if (invalid.length) {
      event.preventDefault();
      error.textContent = invalid.map(name => ({organization:'Enter your church or organization.',name:'Enter your name.',email:'Enter a valid email address.'}[name])).join(' ');
      error.hidden = false;
      field(invalid[0]).focus();
      track('church_quote_validation_error', { missing_fields: invalid.join(',') });
      return;
    }
    save();
    if (nativeSubmission) {
      if (!quoteBody || !quoteSourcePage || !quoteLandingPage || !quoteSubmissionId || !quoteSubmittedAt) {
        event.preventDefault();
        error.textContent = 'This request could not be sent. Please refresh the page and try again.';
        error.hidden = false;
        track('church_quote_submission_error', { reason: 'missing_native_fields' });
        return;
      }
      const attempt=window.mvpRfqSubmission&&window.mvpRfqSubmission.beginNative(form,{widget:'church',submissionId,button:form.querySelector('[type=submit]')});
      if(attempt&&attempt.repeat)return;
      quoteBody.value = requestText();
      quoteSourcePage.value = sourcePage;
      quoteLandingPage.value = window.location.href;
      quoteSubmissionId.value = submissionId;
      quoteSubmittedAt.value = new Date().toISOString();
      track('church_quote_attempt', { selected_products: read().products.join(','), product_count: read().products.length });
      return;
    }
    event.preventDefault();
    summary.textContent = requestText();
    form.hidden = true;
    success.hidden = false;
    success.querySelector('h3').focus();
    track('church_quote_prepare', { selected_products: read().products.join(','), product_count: read().products.length });
  });
  document.querySelector('[data-edit-quote]').addEventListener('click', () => {
    edit();
    field('notes').focus();
  });
  document.querySelector('[data-copy-quote]').addEventListener('click', async () => {
    const status = document.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(requestText());
      status.textContent = 'Request copied.';
      track('church_quote_copy');
    } catch {
      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(summary);
      selection.removeAllRanges();
      selection.addRange(range);
      status.textContent = 'We could not copy the request automatically. The text is selected so you can copy it yourself.';
    }
  });
  form.querySelector('[type=submit]').disabled = false;
  renderVariants();
  window.mvpChurchQuote = { getState: read, getRequestText: requestText };
  if (page === 'church-project-planner' || window.location.hash === '#quote') disclosure.open = true;
})();
